<script setup lang="ts">
const t2 = useT2({
  Newsletter: 'Naujienlaiškis',
  Off: 'Išjungta',
  Subscribed: 'Prenumeruota',
  Subscribe: 'Prenumeruoti',
})

const props = defineProps<{ sellerId: string }>()
const auth = useAuth()
const ads = useAds()

const { recheck, doc } = useBuyerSubscriptions(() => props.sellerId)
const isSubscribed = computed(() => doc.value?.newsletter === true)

function submit(next: boolean): Promise<{
  response: NotVoidPrimitives
  success: boolean
}> {
  return useBuyerSubscriptionsMutation({ set: { sellerId: props.sellerId, newsletter: next } }).then((response) => {
    const success = !!response.data?.buyerSubscription?.responseInfo?.success
    if (next && success) ads.save?.(() => ({ event: 'newsletter', email: auth.value.email }))
    return { response, success }
  })
}
</script>

<template>
  <SubscriptionSellerBtnShell :title="t2('Newsletter')" :submit :recheck :is-subscribed :enabled-label="t2('Subscribed')" :enable-label="t2('Subscribe')" :disabled-label="t2('Off')" />
</template>
